import { all } from 'redux-saga/effects'
import { watchPostsRequest } from './posts.js'
import { watchProjectsRequest } from './projects.js'
import { watchUserRequests } from './users.js'
import { watchAppRequests } from './apps.js'
import { watchSubmissionRequests } from './submissions.js'
import { watchUploadsRequests } from './uploads.js'
import { watchStatsRequests } from './stats.js'

export default function* rootSaga() {
	yield all([
		watchUserRequests(),
		watchAppRequests(),
		watchSubmissionRequests(),
		watchUploadsRequests(),
		watchPostsRequest(),
		watchProjectsRequest(),
		watchStatsRequests()
	])
}



// WEBPACK FOOTER //
// ./src/sagas/index.js